/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAxLjc1VjIuNzVIMTMuMjVWNkgxNC4yNVYxLjc1SDEwWk0xLjc1IDEwSDIuNzVWMTMuMjVINlYxNC4yNUgxLjc1VjEwWk0xMCAxMy4yNUgxMy4yNVYxMEgxNC4yNVYxNC4yNUgxMFYxMy4yNVpNMi43NSA2SDEuNzVWMS43NUg2VjIuNzVIMi43NVY2WiIgZmlsbD0iaW5oZXJpdCIvPg==";